import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/networkHandler";
export const tokenConfig = (getState) => {
  const token = getState().auth.accessToken;

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
};

//Get All PostBack
export const getAllPostBacks = createAsyncThunk(
  "admin/postback",
  async (
    { page, rowsPerPage, name, startDate, endDate },
    { getState, rejectWithValue }
  ) => {
    try {
      const config = tokenConfig(getState);
      let params = `page=${page + 1}&limit=${rowsPerPage}`;
      if (name) {
        params += `&name=${encodeURIComponent(name)}`;
      }
      if (startDate) {
        params += `&startDate=${encodeURIComponent(startDate)}`;
      }
      if (endDate) {
        params += `&endDate=${encodeURIComponent(endDate)}`;
      }
      //console.log(params)
      const response = await axios.get(`/admin/all-postback?${params}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

//Create Postback Settings
export const createPostbackSettings = createAsyncThunk(
  "admin/create-postback-settings",
  async (formData, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.post(`/admin/postback-settings?staticId=1`, formData, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

//Get Postback Settings
export const getPostbackSettings = createAsyncThunk(
  "admin/postback-settings",
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/postback-settings`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
)

const postbackSlice = createSlice({
  name: "postback",
  initialState: {
    loading: false,
    postbacks: [],
    postbackSetting: {
      timeInterval: "0",
      range: "0",
      pbPublisher: "0",
      pbDigiClick: "0",
      staticId: "1"
    },
    meta: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      //get-all-postbacks
      .addCase(getAllPostBacks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllPostBacks.fulfilled, (state, action) => {
        state.loading = false;
        state.postbacks = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(getAllPostBacks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //create-postback-settings
      .addCase(createPostbackSettings.pending, (state) => {
        state.loading = true;
        state.success = null;
        state.error = null;
      })
      .addCase(createPostbackSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(createPostbackSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //get-postback-settings
      .addCase(getPostbackSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPostbackSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.postbackSetting = action.payload.data;
      })
      .addCase(getPostbackSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});
export default postbackSlice.reducer;
